import { generatePath } from 'react-router-dom';

import { PagePaths } from '@/routes/page-paths';

type Params = {
  id: string;
  /** Whether the caller may read a fund belonging to another entity. */
  canReviewCrossEntity: boolean;
  fundApprovalStatus?: string | null;
  draftStatus?: string | null;
};

export function isFundInReapprovalState(
  params: Pick<Params, 'fundApprovalStatus' | 'draftStatus'>,
) {
  return (
    params.draftStatus === 'PendingReview' || params.fundApprovalStatus === 'ReVerificationPending'
  );
}

export function canOpenFundReviewRoute(params: Params) {
  return params.canReviewCrossEntity && isFundInReapprovalState(params);
}

export function getSetupFundReviewOrEditPath(params: Params) {
  const canReview = canOpenFundReviewRoute(params);
  return generatePath(canReview ? PagePaths.setupFundReview : PagePaths.setupFundIdEdit, {
    id: params.id,
  });
}
